import gql from "graphql-tag";

// compact visitor identity + temperature for the inbox + context pane
const CONVO_VISITOR = `
  id
  identified
  contactName
  contactEmail
  contactPhone
  leadTier
  leadScore
  device
  topOperation
  topCategory
  topZone
`;

const CONVO = `
  id
  visitorToken
  status
  agentUnread
  visitorUnread
  lastMessageAt
  lastMessagePreview
  online
  currentPage
  initiator
  guestName
  guestEmail
  guestPhone
  inquiryId
  visitor { ${CONVO_VISITOR} }
`;

const CARD = `id fullAddress propertyType coverImage price`;
const MESSAGE = `id sender body createdAt context property { ${CARD} }`;

// inbox list (no messages — light)
export const AgentConversations = gql`
  query agentConversations($status: String) {
    agentConversations(status: $status) {
      ${CONVO}
    }
  }
`;

// one conversation with full history (loaded on open)
export const AgentConversation = gql`
  query agentConversation($id: ID!) {
    agentConversation(id: $id) {
      ${CONVO}
      messages { ${MESSAGE} }
    }
  }
`;

export const NudgeVisitor = gql`
  mutation nudgeVisitor($visitorToken: String!, $message: String) {
    nudgeVisitor(input: { visitorToken: $visitorToken, message: $message }) {
      conversation { ${CONVO} messages { ${MESSAGE} } }
    }
  }
`;

export const SendAgentMessage = gql`
  mutation sendAgentMessage($conversationId: ID!, $body: String!) {
    sendAgentMessage(input: { conversationId: $conversationId, body: $body }) {
      message { ${MESSAGE} }
    }
  }
`;

export const MarkConversationRead = gql`
  mutation markConversationRead($conversationId: ID!) {
    markConversationRead(input: { conversationId: $conversationId }) { success }
  }
`;

export const CloseConversation = gql`
  mutation closeConversation($conversationId: ID!) {
    closeConversation(input: { conversationId: $conversationId }) { success }
  }
`;

export const ReopenConversation = gql`
  mutation reopenConversation($conversationId: ID!) {
    reopenConversation(input: { conversationId: $conversationId }) { success }
  }
`;

export const ShareProperty = gql`
  mutation shareProperty($conversationId: ID!, $propertyId: ID!, $body: String) {
    shareProperty(input: { conversationId: $conversationId, propertyId: $propertyId, body: $body }) {
      message { ${MESSAGE} }
    }
  }
`;

// journey-based recommendations for the selected visitor (the property picker)
export const RecommendedForVisitor = gql`
  query recommendedForVisitor($visitorToken: String, $agencyIds: [ID!], $limit: Int) {
    recommendedForVisitor(visitorToken: $visitorToken, agencyIds: $agencyIds, limit: $limit) {
      id
      fullAddress
      propertyType
      price
      trending
      images { smallUrl thumbUrl }
    }
  }
`;
